import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const ViewStateLoadedSlice = createSlice({
  name: 'viewStateLoaded',
  initialState: false,
  reducers: {
    setViewStateLoaded(_, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setViewStateLoaded } = ViewStateLoadedSlice.actions;

const ViewStateLoadedReducer = ViewStateLoadedSlice.reducer;

export default ViewStateLoadedReducer;